import axios from "axios";
import CheckHttp from "@/asyncs/MyHttpCheck.js";
import {
    Notify,
    Toast
} from "vant";
import Env from "@/logics/Envs.js";

export default async function (sessionId, data) {
    const waitingToast = Toast.loading({
        forbidClick: true,
        duration: 0
    });
    try {
        const toSend = new FormData();
        toSend.append("sessionId", sessionId);
        toSend.append("json", JSON.stringify(data));
        const res = await axios.post(Env.apiPath + "checkInSessionAll", toSend);
        if (res.data.error) {
            Notify({
                type: "danger",
                message: res.data.error,
                duration: 5000
            });
            return false;
        }
        return true;
    } catch (err) {
        CheckHttp(err);
        return false;
    } finally {
        waitingToast.clear();
    }
}